export default __webpack_public_path__ + "static/media/cv.b52642ce.pdf";